module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-03@2x-33b2d2f722ad132ac20b103496898980.webp";